import org.w3c.dom.HTMLCanvasElement
import org.khronos.webgl.WebGLRenderingContext as GL //# GL# we need this for the constants declared ˙HUN˙ a constansok miatt kell
import kotlin.js.Date

class Scene (
  val gl : WebGL2RenderingContext){

  val timeAtFirstFrame = Date().getTime()
  var timeAtLastFrame =  timeAtFirstFrame

  var avatarPostX = 0.0f
  var avatarPostY = 0.0f

  val vsIdle = Shader(gl, GL.VERTEX_SHADER, "idle-vs.glsl") //loading stuff and compiling shaders
  val fsSolid = Shader(gl, GL.FRAGMENT_SHADER, "solid-fs.glsl")
  val fsSecondary = Shader(gl, GL.FRAGMENT_SHADER, "secondary-fs.glsl")
  val fsRainbow = Shader(gl, GL.FRAGMENT_SHADER, "rainbow-fs.glsl")


  val program = Program(gl, vsIdle, fsSolid, arrayOf( //changed from solidProgram
    "vertexPosition",
    "vertexColor"))

  val secondary = Program(gl, vsIdle, fsSecondary, arrayOf( //changed from fsSolid
    "vertexPosition",
    "vertexColor"))

  val rainbow = Program(gl, vsIdle, fsRainbow, arrayOf( //changed from fsSecondary
    "vertexPosition",
    "vertexColor"))

  val triangleGeometry = TriangleGeometry(gl)
  val quadGeometry = QuadGeometry(gl)
  val circleGeometry = CircleGeometry(gl)
  val donutGeometry = DonutGeometry(gl)
  val heartGeometry = HeartGeometry(gl)


  fun resize(canvas : HTMLCanvasElement) {
    gl.viewport(0, 0, canvas.width, canvas.height)//#viewport# tell the rasterizer which part of the canvas to draw to ˙HUN˙ a raszterizáló ide rajzoljon
  }

  @Suppress("UNUSED_PARAMETER")
  fun update(keysPressed : Set<String>) { //called in every frame - drawing stuff

    val timeAtThisFrame = Date().getTime() 
    val dt = (timeAtThisFrame - timeAtLastFrame).toFloat() / 1000.0f
    val t  = (timeAtThisFrame - timeAtFirstFrame).toFloat() / 1000.0f    
    timeAtLastFrame = timeAtThisFrame

    //console.log(1.0 / dt) //frame rate

    if("RIGHT" in keysPressed){
      avatarPostX += 0.01f
  }

    if("LEFT" in keysPressed){
      avatarPostX += -0.01f
  }

    if("UP" in keysPressed){
      avatarPostY += 0.01f
  }

    if("DOWN" in keysPressed){
      avatarPostY += -0.01f
  }

    if (avatarPostX >= 1.0f){
      avatarPostX = -0.98f }

    if (avatarPostX <= -1.0f){
      avatarPostX = 0.98f }


    if (avatarPostY >= 1.0f){
      avatarPostY = -0.98f }

    if (avatarPostY <= -1.0f){
      avatarPostY = 0.98f }


    gl.clearColor(0.7f, 0.7f, 0.85f, 1.0f)//## red, green, blue, alpha in [0, 1] (clears the canvas)
    gl.clearDepth(1.0f)//## will be useful in 3D ˙HUN˙ 3D-ben lesz hasznos
    gl.clear(GL.COLOR_BUFFER_BIT or GL.DEPTH_BUFFER_BIT)//#or# bitwise OR of flags

    gl.useProgram(program.glProgram) //which shaders to use - solidProgram
    //set uniform here
    gl.uniform3f(
      gl.getUniformLocation(
      program.glProgram,
      "gameObject.scale"),
    0.3f * 0.5f * kotlin.math.cos((t / 5.0f)), 0.3f * 0.5f * kotlin.math.sin(t / 5.0f), 0.1f
);

    gl.useProgram(program.glProgram) //which shaders to use - solidProgram
    //set uniform here
    gl.uniform3f(
      gl.getUniformLocation(
      program.glProgram,
      "gameObject.position"),
      avatarPostX + 0.5f * kotlin.math.cos((t / 5.0f)), avatarPostY + 0.5f * kotlin.math.sin(t / 5.0f), 0.1f
);

    quadGeometry.draw() //calls quad geometry draw methods (buffers etc)

    gl.useProgram(rainbow.glProgram) //which shaders to use - solidProgram
    //set uniform here
    gl.uniform3f(
      gl.getUniformLocation(
      rainbow.glProgram,
      "gameObject.position"),
    avatarPostX, avatarPostY, 0.0f
);

    gl.useProgram(rainbow.glProgram) //which shaders to use - solidProgram
    //set uniform here
    gl.uniform3f(
      gl.getUniformLocation(
      rainbow.glProgram,
      "gameObject.scale"),
    0.4f, 0.4f, 0.5f
);

    gl.useProgram(rainbow.glProgram) //which shaders to use - solidProgram
    //set uniform here
    gl.uniform3f(
      gl.getUniformLocation(
      rainbow.glProgram,
      "gameObject.time"), //only the x value matters for line thickness, idk why it makes me input a vec3
    t, 0.0f, 0.0f
);

   triangleGeometry.draw() //calls triangle geometry draw methods (buffers etc)


       gl.useProgram(secondary.glProgram) //which shaders to use - solidProgram
    //set uniform here
    gl.uniform3f(
      gl.getUniformLocation(
      secondary.glProgram,
      "gameObject.scale"),
      0.2f, 0.2f, 1.0f
);

    gl.useProgram(secondary.glProgram) //which shaders to use - solidProgram
    //set uniform here
    gl.uniform3f(
      gl.getUniformLocation(
      secondary.glProgram,
      "gameObject.position"),
    -0.35f - 0.005f * ((1.0f + kotlin.math.sin(4.0f * t - 1.0f))), 0.3f - 0.2f * ((1.0f + kotlin.math.sin(t + 1.0f))), 0.0f
);

    gl.useProgram(secondary.glProgram) //which shaders to use - solidProgram
    //set uniform here
    gl.uniform3f(
      gl.getUniformLocation(
      secondary.glProgram,
      "gameObject.line_thick"), //only the x value matters for line thickness, idk why it makes me input a vec3
    0.5f * (1.0f + kotlin.math.cos(t)), 0.0f, 0.0f
);

    gl.useProgram(secondary.glProgram) //which shaders to use - solidProgram
    //set uniform here
    gl.uniform3f(
      gl.getUniformLocation(
      secondary.glProgram,
      "gameObject.line_color"), //only the x value matters for line thickness, idk why it makes me input a vec3
    0.2f, 0.1f, 0.3f
);

    gl.useProgram(secondary.glProgram) //which shaders to use - solidProgram
    //set uniform here
    gl.uniform3f(
      gl.getUniformLocation(
      secondary.glProgram,
      "gameObject.time"), //only the x value matters for line thickness, idk why it makes me input a vec3
    2.5f * t + 10.0f, 0.0f, 0.0f
);

    donutGeometry.draw() //calls triangle geometry draw methods (buffers etc)


    gl.useProgram(secondary.glProgram) //which shaders to use - solidProgram
    //set uniform here
    gl.uniform3f(
      gl.getUniformLocation(
      secondary.glProgram,
      "gameObject.scale"),
    0.2f, 0.2f, 0.3f
);

    gl.useProgram(secondary.glProgram) //which shaders to use - solidProgram
    //set uniform here
    gl.uniform3f(
      gl.getUniformLocation(
      secondary.glProgram,
      "gameObject.position"),
    0.4f + 0.1f * (1.0f + kotlin.math.cos(t)), 0.4f + 0.1f * (1.0f + kotlin.math.sin(t)), 0.0f
);

    gl.useProgram(secondary.glProgram) //which shaders to use - solidProgram
    //set uniform here
    gl.uniform3f(
      gl.getUniformLocation(
      secondary.glProgram,
      "gameObject.line_thick"), //only the x value matters for line thickness, idk why it makes me input a vec3
    0.3f, 0.0f, 0.0f
);

    gl.useProgram(secondary.glProgram) //which shaders to use - solidProgram
    //set uniform here
    gl.uniform3f(
      gl.getUniformLocation(
      secondary.glProgram,
      "gameObject.line_color"), //only the x value matters for line thickness, idk why it makes me input a vec3
    0.8f, 0.2f, 0.2f
);

    gl.useProgram(secondary.glProgram) //which shaders to use - solidProgram
    //set uniform here
    gl.uniform3f(
      gl.getUniformLocation(
      secondary.glProgram,
      "gameObject.time"), //only the x value matters for line thickness, idk why it makes me input a vec3
    t, 0.0f, 0.0f
);

    heartGeometry.draw() //calls donut geometry draw methods (buffers etc)

  }
}
